export function brandPossessive(brandName) {
    return brandName.endsWith("s") ? `${brandName}'` : `${brandName}'s`;
}
